const QUEBEC_GEOCODER = 'https://servicescarto.mern.gouv.qc.ca/pes/rest/services/Territoire/Adresse_Geocodage/GeocodeServer';

const pin = () => ({
  type: 'picture-marker',
  url: window.location.protocol + '//' + window.location.host + '/static/img/icons/pin.png',
  size: 24,
  width: 24,
  height: 24,
  xoffset: 0,
  yoffset: 0
});

export default function createSearch(Search, Locator, { view, searchSource, placeholder, streetsLayer, streets }) {
  const source = searchSource || {};
  const search = new Search({
    view: view,
    autoSelect: true,
    label: 'Some Label',
    locationEnabled: false,
    minSuggestCharacters: 3,
    popupEnabled: false,
    searchAllEnabled: true,
    declaredClass: 'hello',
    includeDefaultSources: !!source.isDefaultESRI,
    resultGraphicEnabled: true,
    sources: [],
    resultSymbol: pin()
  });
  if (source.isQuebec) {
    search.sources.push({
      locator: new Locator({ url: QUEBEC_GEOCODER }),
      singleLineFieldName: 'SingleLine',
      name: 'Adresses Quebec Geocodage',
      placeholder: placeholder,
      maxResults: 50,
      maxSuggestions: 6,
      outFields: ['*'],
      resultGraphicEnabled: true,
      resultSymbol: pin()
    });
  }
  if (source.isDefaultCenterline) {
    search.sources.push({
      layer: streetsLayer,
      searchFields: streets.searchFields,
      displayField: streets.displayField,
      exactMatch: false,
      prefix: '',
      suffix: '',
      maxResults: 50,
      maxSuggestions: 6,
      name: 'Rue',
      outFields: ['*'],
      placeholder: placeholder,
      resultGraphicEnabled: true
    });
  }
  return search;
}
